import * as Sentry from '@sentry/react'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { initProxyConfig } from './hooks/useProxyConfig'
import './index.css'

Sentry.init({
  dsn: 'https://156ca1b79a3e9da0a836772e08737af1@o4511502984478720.ingest.de.sentry.io/4511513130369104',
  enabled: import.meta.env.PROD,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 0.1,
  environment: import.meta.env.MODE,
})

initProxyConfig()

// Aplica el tema antes de renderizar para evitar flash
const savedTheme = localStorage.getItem('theme') ?? 'dark'
if (savedTheme === 'dark') document.documentElement.classList.add('dark')

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
